


































































import FormCustomerBilling from '@/app/shared/components/forms/customer-billing.vue';
import FormCustomerInsurance from '@/app/shared/components/forms/customer-insurance.vue';
import {
  AddressBillingModel,
  AddressInsuranceModel,
  ContactBillingModel,
  ContactInsuranceModel,
  CustomerBillingModel,
  CustomerInsuranceModel,
  VForm,
} from '@/app/shared/models';
import { refsService } from '@/app/shared/refs.service';
import { Component, Ref, Vue, Watch } from 'vue-property-decorator';
@Component({ components: { FormCustomerBilling, FormCustomerInsurance } })
export default class DialogCampaignCreateComponent extends Vue {
  @Ref() private formBilling!: VForm;
  @Ref() private formInsurance!: VForm;

  private customerBilling: CustomerBillingModel = new CustomerBillingModel();
  private customerInsurance: CustomerInsuranceModel = new CustomerInsuranceModel();

  private newAddress = false;
  private newEmail = false;
  private newPhone = false;
  private newCellPhone = false;

  private dialog = false;
  private valueTab = '';

  private get refs() {
    return refsService;
  }
  private get rules() {
    return this.refs.static.rules;
  }
  private get contractModule() {
    return this.refs.modules.contract;
  }
  private get policyModule() {
    return this.refs.modules.policy;
  }

  private async saveCustomerBilling() {
    if (this.formBilling && !this.formBilling.validate()) {
      // Run after the next update cycle
      this.$nextTick(() => {
        const el = document.querySelector(
          '.v-messages.error--text:first-of-type'
        );
        if (el) {
          el.scrollIntoView();
        }
      });
      this.$toast(this.$t('toasts.incomplete_or_invalid_fields'));
      return;
    }
    if (this.formBilling && this.formBilling.validate()) {
      await this.contractModule
        .updateCustomer({
          contractId: this.contractModule.contract.Id,
          customerId: this.customerBilling.Id,
          customer: this.customerBilling,
          newAddress: this.newAddress,
          newEmail: this.newEmail,
          newPhone: this.newPhone,
          newCellPhone: this.newCellPhone,
          descReason: this.valueTab,
        })
        .then(async () => {
          this.$toast(this.$t('toasts.change_personal_data_successfully'));
          this.refs.modules.ticket.SET_EDIT_PERSONAL_DATA(true);
          await this.contractModule
            .loadCustomerByContractId(this.$route.params.id)
            .then(() => {
              localStorage.removeItem('tabulacao');
              this.$bus.$emit('cleanValueTab');
            });
          this.dialog = false;
        })
        .catch((err) => {
          this.$toast.error('ERROR ? ', err);
          this.$toast.error(this.$t('toasts.change_personal_data_error'));
        });
    }
  }
  private async saveCustomerInsurance() {
    if (this.formInsurance && !this.formInsurance.validate()) {
      // Run after the next update cycle
      this.$nextTick(() => {
        const el = document.querySelector(
          '.v-messages.error--text:first-of-type'
        );
        if (el) {
          el.scrollIntoView();
        }
      });
      this.$toast(this.$t('toasts.incomplete_or_invalid_fields'));
      return;
    }
    if (this.formInsurance && this.formInsurance.validate()) {
      await this.policyModule
        .updateCustomer({
          policyId: this.policyModule.policy.Id,
          customer: this.customerInsurance,
          newAddress: this.newAddress,
          newEmail: this.newEmail,
          newPhone: this.newPhone,
          newCellPhone: this.newCellPhone,
        })
        .then(async () => {
          this.$toast(this.$t('toasts.change_personal_data_successfully'));
          this.refs.modules.ticket.SET_EDIT_PERSONAL_DATA(true);
          this.refs.generateInteractions.personalDataInsurance(
            this.refs.modules.policy.customer,
            this.customerInsurance,
            this.valueTab
          );
          this.refs.generateInteractions.personalDataContactInsurance(
            this.refs.util.findEmail(this.policyModule.customer.Contacts),
            this.policyModule.email,
            true,
            this.valueTab
          );
          this.refs.generateInteractions.personalDataContactInsurance(
            this.refs.util.findPhone(this.policyModule.customer.Contacts),
            this.policyModule.phone,
            false,
            this.valueTab
          );
          this.refs.generateInteractions.personalDataContactInsurance(
            this.refs.util.findCellphone(this.policyModule.customer.Contacts),
            this.policyModule.cellPhone,
            false,
            this.valueTab
          );
          this.refs.generateInteractions.personalDataAddressInsurance(
            this.refs._.head(this.policyModule.customer.Addresses),
            this.policyModule.address,
            this.valueTab
          );
          await this.policyModule
            .loadCustomerByPolicyId(this.$route.params.id)
            .then(() => {
              localStorage.removeItem('tabulacao');
              this.$bus.$emit('cleanValueTab');
            });
          this.dialog = false;
        })
        .catch((err) => {
          this.$toast.error('ERROR ? ', err);
          this.$toast.error(this.$t('toasts.change_personal_data_error'));
        });
    }
  }

  @Watch('dialog')
  private onChangeDialog(value: boolean) {
    this.valueTab = localStorage.getItem('tabulacao') ?? '';
    if (value) {
      if (this.formInsurance) this.formInsurance.resetValidation();
      if (this.formBilling) this.formBilling.resetValidation();
      if (this.refs.modules.data.isBilling) {
        this.customerBilling = this.refs._.clone(this.contractModule.customer);
        const address = this.refs._.clone(
          this.refs._.head(this.contractModule.customer.Addresses)
        );
        if (address) {
          this.contractModule.SET_ADDRESS(address);
          this.newAddress = false;
        } else {
          this.contractModule.SET_ADDRESS(new AddressBillingModel());
          this.newAddress = true;
        }
        const email = this.refs._.clone(
          this.refs.util.findEmail(this.contractModule.customer.Contacts)
        );
        if (email) {
          this.contractModule.SET_EMAIL(email);
          this.newEmail = false;
        } else {
          this.contractModule.SET_EMAIL(
            new ContactBillingModel(this.refs.enums.ContactType.Email, 'Email')
          );
          this.newEmail = true;
        }
        const phone = this.refs._.clone(
          this.refs.util.findPhone(this.contractModule.customer.Contacts)
        );
        if (phone) {
          this.contractModule.SET_PHONE(phone);
          this.newPhone = false;
        } else {
          this.contractModule.SET_PHONE(
            new ContactBillingModel(this.refs.enums.ContactType.Phone, 'Phone')
          );
          this.newPhone = true;
        }
        const cellPhone = this.refs._.clone(
          this.refs.util.findCellphone(this.contractModule.customer.Contacts)
        );
        if (cellPhone) {
          this.contractModule.SET_CELLPHONE(cellPhone);
          this.newCellPhone = false;
        } else {
          this.contractModule.SET_CELLPHONE(
            new ContactBillingModel(
              this.refs.enums.ContactType.CellPhone,
              'CellPhone'
            )
          );
          this.newCellPhone = true;
        }
      } else {
        this.customerInsurance = this.refs._.clone(this.policyModule.customer);
        const address = this.refs._.clone(
          this.refs._.head(this.policyModule.customer.Addresses)
        );
        if (address) {
          this.policyModule.SET_ADDRESS(address);
          this.newAddress = false;
        } else {
          this.policyModule.SET_ADDRESS(new AddressInsuranceModel());
          this.newAddress = true;
        }
        const email = this.refs._.clone(
          this.refs.util.findEmail(this.policyModule.customer.Contacts)
        );
        if (email) {
          this.policyModule.SET_EMAIL(email);
          this.newEmail = false;
        } else {
          this.policyModule.SET_EMAIL(
            new ContactInsuranceModel(
              this.refs.enums.ContactType.Email,
              'Email'
            )
          );
          this.newEmail = true;
        }
        const phone = this.refs._.clone(
          this.refs.util.findPhone(this.policyModule.customer.Contacts)
        );
        if (phone) {
          this.policyModule.SET_PHONE(phone);
          this.newPhone = false;
        } else {
          this.policyModule.SET_PHONE(
            new ContactBillingModel(this.refs.enums.ContactType.Phone, 'Phone')
          );
          this.newPhone = true;
        }
        const cellPhone = this.refs._.clone(
          this.refs.util.findCellphone(this.policyModule.customer.Contacts)
        );
        if (cellPhone) {
          this.policyModule.SET_CELLPHONE(cellPhone);
          this.newCellPhone = false;
        } else {
          this.policyModule.SET_CELLPHONE(
            new ContactBillingModel(
              this.refs.enums.ContactType.CellPhone,
              'CellPhone'
            )
          );
          this.newCellPhone = true;
        }
      }
    }
  }
}
